<template>
  <div v-if="isVisible" class="update-logs-modal-overlay">
    <div class="update-logs-modal">
      <div class="update-logs-modal-header">
        <h3>📋 تاریخچه بروزرسانی‌ها</h3>
        <i @click="closeModal" class="fa-solid fa-x close-btn"></i>
      </div>
      
      <div class="update-logs-modal-content">
        <div v-if="updateLogs.length === 0" class="no-updates">
          <i class="fa-solid fa-info-circle"></i>
          <p>هنوز بروزرسانی‌ای انجام نشده است.</p>
        </div>
        
        <div v-else class="update-logs-list">
          <div v-for="(log, index) in updateLogs" :key="index" class="update-log-item">
                         <div class="update-log-header">
               <div class="version-badge">
                 <i class="fa-solid fa-code-branch"></i>
                 نسخه {{ log.version }}
               </div>
               <div class="update-date">
                                   <div class="date-info">
                    <span class="date-label">تاریخ:</span>
                    <span class="date-value">{{ formatDate(log.date) }}</span>
                  </div>
                 
               </div>
             </div>
            
            <div class="update-log-changes">
              <h4>تغییرات:</h4>
              <ul class="changes-list">
                <li v-for="(change, changeIndex) in log.changes" :key="changeIndex">
                  {{ change }}
                </li>
              </ul>
            </div>
            
            
          </div>
        </div>
      </div>
      
                           <div class="update-logs-modal-footer">
          <button @click="closeModal" class="close-btn-footer">
            <i class="fa-solid fa-times"></i>
            بستن
          </button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateLogsModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    updateLogs: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },

    formatDate(dateString) {
      // For manual dates, just return as is
      return dateString;
    },

  }
}
</script>

<style scoped>
.update-logs-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
  backdrop-filter: blur(5px);
}

.update-logs-modal {
  background-color: #1a1a1a;
  border-radius: 15px;
  padding: 25px;
  max-width: 90vw;
  width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  border: 2px solid #6153cc;
}

.update-logs-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #333;
}

.update-logs-modal-header h3 {
  color: #fff;
  margin: 0;
  font-size: 22px;
  font-weight: bold;
  font-family: IRANSansWeb;
}

.close-btn {
  color: #888;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-btn:hover {
  color: #fff;
  background-color: #333;
}

.update-logs-modal-content {
  color: #fff;
  margin-bottom: 20px;
}

.no-updates {
  text-align: center;
  padding: 40px 20px;
  color: #888;
}

.no-updates i {
  font-size: 48px;
  margin-bottom: 15px;
  color: #6153cc;
}

.no-updates p {
  font-size: 16px;
  font-family: IRANSansWeb;
  margin: 0;
}

.update-logs-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.update-log-item {
  background-color: #2a2a2a;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #444;
  transition: all 0.3s ease;
}

.update-log-item:hover {
  border-color: #6153cc;
  transform: translateY(-2px);
}

.update-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #444;
}

.version-badge {
  background: linear-gradient(135deg, #6153cc 0%, #fd7691 100%);
  color: white;
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  font-family: IRANSansWeb;
}

.version-badge i {
  margin-left: 8px;
}

.update-date {
  color: #888;
  font-size: 14px;
  font-family: IRANSansWeb;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.date-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.date-label {
  color: #aaa;
  font-size: 12px;
  font-weight: bold;
}

.date-value {
  color: #888;
  font-size: 13px;
}

.update-log-changes h4 {
  color: #fff;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  font-family: IRANSansWeb;
}

.changes-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.changes-list li {
  padding: 5px 0;
  padding-right: 20px;
  position: relative;
  font-size: 14px;
  line-height: 1.5;
  font-family: IRANSansWeb;
  color: #ccc;
}

.changes-list li:before {
  content: "•";
  color: #6153cc;
  font-weight: bold;
  position: absolute;
  right: 0;
  top: 5px;
}

.update-log-status {
  margin-top: 15px;
  text-align: left;
}



.update-logs-modal-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #333;
}



.close-btn-footer {
  background-color: #666;
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: bold;
  font-family: IRANSansWeb;
  cursor: pointer;
  transition: all 0.3s ease;
}

.close-btn-footer:hover {
  background-color: #888;
}

.close-btn-footer i {
  margin-left: 8px;
}

@media (max-width: 768px) {
  .update-logs-modal {
    margin: 20px;
    padding: 20px 20px 20px 5px;
    width: calc(100vw - 40px);
  }
  
  .update-log-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .changes-list li {
    font-size: 13px;
  }
}
</style>
